module.exports = __webpack_public_path__ + "static/media/74.98112042.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/74.jpg
// module id = 1012
// module chunks = 0